<template>
  <v-btn
    class="app-button-load-more"
    :variant="variant"
    :color="color"
    :size="size"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <div class="app-button-load-more__content">
      <v-progress-circular
        v-if="loading"
        indeterminate
        :size="size === 'small' ? 16 : 18"
        :width="2"
        class="app-button-load-more__spinner"
      />
      <v-icon v-else size="18">mdi-refresh</v-icon>
      <span>{{ label }}</span>
    </div>
  </v-btn>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    loading?: boolean;
    disabled?: boolean;
    size?: "default" | "small" | "large";
    color?: string;
    label?: string;
    variant?: "text" | "flat" | "outlined";
  }>(),
  {
    loading: false,
    disabled: false,
    size: "default",
    color: "primary",
    label: "Load more",
    variant: "text",
  },
);

const emit = defineEmits<{ (e: "click"): void }>();

function handleClick() {
  if (props.disabled || props.loading) return;
  emit("click");
}
</script>

<style scoped>
.app-button-load-more {
  text-transform: capitalize;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.app-button-load-more__content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.app-button-load-more__spinner {
  color: currentColor;
}
</style>
